import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

const it = {
  common: {
    loading: 'Caricamento…',
    error: 'Errore',
    save: 'Salva',
    cancel: 'Annulla',
    confirm: 'Conferma',
    delete: 'Elimina',
    edit: 'Modifica',
    close: 'Chiudi',
    back: 'Indietro',
    next: 'Avanti',
    submit: 'Invia',
    search: 'Cerca',
    filter: 'Filtri',
    export: 'Esporta',
    download: 'Scarica',
    share: 'Condividi',
    yes: 'Sì',
    no: 'No',
    all: 'Tutti',
    none: 'Nessuno',
    notAvailable: 'N/D',
    required: 'Campo obbligatorio',
    optional: 'Facoltativo',
    actions: 'Azioni',
    details: 'Dettagli',
    version: 'Versione',
    date: 'Data',
    status: 'Stato',
    score: 'Punteggio',
    verdict: 'Verdetto',
    note: 'Note',
    label: 'Etichetta',
    results: 'Risultati',
    page: 'Pagina',
    of: 'di',
    open: 'Apri',
    unexpectedError: 'Errore imprevisto',
    previous: 'Precedente',
  },
  nav: {
    dashboard: 'Dashboard',
    newAssessment: 'Nuova Valutazione',
    reviewQueue: 'Da Validare',
    audit: 'Registro Audit',
    profile: 'Profilo',
    logout: 'Esci',
    darkMode: 'Modalità scura',
    lightMode: 'Modalità chiara',
    language: 'Lingua',
    history: 'Cronologia',
    historyPersonal: 'Cronologia personale',
    registro: 'Registro strumenti IA',
    documenti: "Documenti d'istituto",
    guida: 'Guida',
    governance: "Governance d'istituto",
    school: 'Il mio Istituto',
    platform: 'Piattaforma',
    maintenance: 'Modalità manutenzione',
    dpoDashboard: 'Cruscotto DPO',
    activityLog: 'Registro attività',
    reviewQueueCrumb: 'Coda di revisione',
    newAssessmentCrumb: 'Nuova valutazione',
    assessmentCrumb: 'Valutazione',
    menu: 'Menu',
    management: 'Gestione',
    searchCmd: 'Cerca…',
    home: 'Home',
    skipToContent: 'Salta al contenuto',
    openMenu: 'Apri menu di navigazione',
    closeMenu: 'Chiudi menu di navigazione',
    breadcrumb: 'Percorso di navigazione',
    tagline: 'Rischio IA a Scuola',
    delegationBadge: 'Delega DS fino al {{date}}',
    delegationTitle: 'Delega del Dirigente {{name}} — valida fino al {{date}}',
    footerTagline: 'Valutazione del Rischio IA a Scuola',
    footerDesign: 'Interfaccia conforme al Design system .italia',
  },
  palette: {
    placeholder: 'Cerca valutazioni, naviga, esegui azioni…',
    noResults: 'Nessun risultato.',
    navigation: 'Navigazione',
    actionsGroup: 'Azioni',
    recent: 'Valutazioni recenti',
    toggleTheme: 'Cambia tema',
    navigateHint: 'naviga',
    openHint: 'apri',
  },
  auth: {
    loginTitle: 'Accedi',
    loginSubtitle: 'Valutazione del Rischio IA a scuola',
    loginGoogle: 'Accedi con Google',
    loginMicrosoft: 'Accedi con Microsoft 365',
    loginDesc: "Usa l'account istituzionale della scuola per accedere al sistema.",
    logoutSuccess: 'Logout effettuato con successo',
    unauthorized: 'Autenticazione richiesta',
    forbidden: 'Accesso non autorizzato',
    sessionExpired: 'Sessione scaduta. Accedi nuovamente.',
  },
  dashboard: {
    title: 'Dashboard',
    welcome: 'Benvenuto',
    totalAssessments: 'Valutazioni totali',
    completedAssessments: 'Completate',
    recentAssessments: 'Valutazioni recenti',
    newAssessment: 'Nuova Valutazione',
    viewAll: 'Vedi tutte',
    noAssessments: 'Nessuna valutazione trovata. Inizia con una nuova valutazione.',
    eyebrow: 'Cruscotto',
    stats: {
      verde: 'App Approvate',
      giallo: 'Sperimentazione',
      rosso: 'Non Conformi',
    },
    charts: {
      overTime: 'Valutazioni nel tempo',
      byMonth: 'Esiti per mese',
      total: 'Totale',
      verde: 'Verde',
      giallo: 'Giallo',
      rosso: 'Rosso',
      vietato: 'Vietato',
    },
    news: {
      title: 'Aggiornamenti Normativi',
      framework: 'Framework Normativo',
      aiact: {
        title: 'AI Act in vigore',
        body: 'Il Regolamento (UE) 2024/1689 è applicabile dal 2 agosto 2026. Le scuole devono classificare i sistemi IA utilizzati.',
      },
      mim: {
        title: 'Linee Guida MIM DM 166/2025',
        body: 'Il Ministero dell\'Istruzione ha pubblicato le linee guida per l\'uso responsabile dell\'IA nella scuola italiana.',
      },
    },
  },
  quota: {
    titleFree: 'Piano Gratuito · {{used}}/{{quota}} valutazioni usate',
    titleSchool: 'Piano dell\'istituto · {{used}}/{{quota}} valutazioni usate quest\'anno',
    exhaustedFree: 'Hai raggiunto il limite massimo del piano gratuito. Passa a un piano a pagamento per continuare.',
    exhaustedSchool: 'L\'istituto ha raggiunto il limite di valutazioni incluse nel piano per l\'anno in corso. Contatta il Dirigente o il DPO per un upgrade.',
    remaining_one: 'Te ne resta ancora 1.',
    remaining_other: 'Te ne restano ancora {{count}}.',
  },
  history: {
    title: 'Cronologia delle richieste di valutazione',
    items: 'elementi',
    searchPlaceholder: 'Cerca per nome dello strumento…',
    searchAria: 'Cerca nelle valutazioni per nome dello strumento',
    noResults: 'Nessuna valutazione trovata per «{{search}}».',
    empty: 'Non hai ancora effettuato nessuna valutazione.',
    createFirst: 'Crea la tua prima valutazione',
  },
  registro: {
    eyebrow: "Governance IA d'istituto",
    title: 'Registro degli strumenti IA autorizzati',
    subtitle: "Strumenti di intelligenza artificiale validati e autorizzati all'uso nella tua istituzione.",
    demoTitle: 'Dati dimostrativi',
    demoBody: "Questa tabella è un esempio dimostrativo. Con il piano d'istituto il registro è alimentato dalle valutazioni validate dal DPO/Dirigente e riflette gli strumenti realmente autorizzati nella tua scuola.",
    tableTitle: 'Strumenti registrati',
    tableTitleDemo: 'Strumenti registrati (esempio)',
    headers: {
      strumento: 'Strumento',
      fornitore: 'Fornitore',
      categoria: 'Categoria',
      stato: 'Stato',
      validazione: 'Validazione',
      note: 'Note',
      azioni: 'Azioni',
    },
    stato: {
      AUTORIZZATO: 'Autorizzato',
      CON_LIMITAZIONI: 'Con limitazioni',
      SOSPESO: 'Sospeso',
      DA_RIVALUTARE: 'Da rivalutare',
      NON_AUTORIZZATO: 'Non autorizzato',
      VALIDATO_DPO: 'Validato dal DPO',
      ANALIZZATO: 'Analizzato',
      REVOCATO: 'Revocato',
    },
    pending: 'In attesa',
    pendingAuth: 'In attesa di autorizzazione',
    emptyTitle: 'Nessuno strumento ancora presente nel registro.',
    emptyHint: "Le valutazioni completate dell'istituto compariranno qui; una volta validate dal DPO/Dirigente risulteranno autorizzate.",
    validatedBy: 'Validato da {{name}}',
    revalidationExpired: 'Validità scaduta il {{date}} — ri-analisi richiesta (DM 166/2025 §10.1)',
    revalidationEngine: 'Motore di valutazione aggiornato — ri-analisi richiesta',
    incident: {
      revoked: 'Revocato dal Dirigente — {{reason}}',
      revokedOn: 'Revocato dal Dirigente il {{date}} — {{reason}}',
      analyzed: 'Sospeso il {{date}} — analisi DPO registrata, in attesa della decisione del Dirigente',
      waitingDpo: "Sospeso il {{date}} — in attesa dell'analisi DPO",
      waitingDpoBy: "Sospeso il {{date}} da {{name}} — in attesa dell'analisi DPO",
    },
    actions: {
      suspend: 'Sospendi',
      dpo: 'Analisi DPO',
      decide: 'Decidi',
      lift: 'Ripristina',
      waitDpo: 'Attesa analisi DPO',
      waitDs: 'Attesa decisione DS',
      dossier: 'Dossier',
      dossierTitle: 'Scarica il dossier ispettivo (valutazioni, report, run, incidenti, documenti, audit)',
    },
    dialog: {
      suspendTitle: 'Sospendi lo strumento',
      dpoTitle: 'Registra analisi DPO',
      decideTitle: 'Decisione del Dirigente',
      liftTitle: 'Ripristina lo strumento',
      suspendInfo: "La sospensione è immediata e visibile a tutto l'istituto. Il processo prosegue con l'analisi del DPO e la decisione del Dirigente (ripristino o revoca).",
      dpoAnalysisOf: 'Analisi del DPO',
      decision: 'Decisione',
      restoreOption: 'Ripristino — lo strumento torna allo stato della catena',
      revokeOption: 'Revoca — lo strumento resta bloccato come REVOCATO',
      suspendLabel: 'Motivazione (obbligatoria, min 20 caratteri)',
      dpoLabel: 'Analisi del DPO (obbligatoria, min 20 caratteri)',
      decideLabel: 'Note (facoltative)',
      liftLabel: 'Motivazione del ripristino (obbligatoria, min 20 caratteri)',
      suspendPlaceholder: 'Es.: segnalazione data breach del fornitore del 10/07…',
    },
    toastOk: 'Operazione registrata',
    toastKo: 'Operazione non riuscita',
    demo: {
      catContenuti: 'Generazione contenuti',
      catTutoring: 'Tutoring IA',
      catAmministrazione: 'Amministrazione',
      catRicerca: 'Ricerca',
      noteChatgpt: 'Solo docenti, no dati personali alunni',
      noteGemini: 'Account istituzionali Workspace',
      noteCopilot: 'Uso in segreteria',
      noteCanva: 'Incidente in corso: analisi DPO',
      noteKhanmigo: 'Validato dal DPO, in attesa di autorizzazione',
      notePerplexity: "Analizzato dall'IA, non ancora validato",
    },
  },
  documenti: {
    eyebrow: "Governance IA d'istituto",
    title: "Documenti d'istituto",
    subtitle: 'DPA, delibere, verbali e nomine con hash SHA-256 e versioni. I documenti collegati a uno strumento entrano nel suo dossier ispettivo.',
    upload: 'Carica documento',
    freeTitle: 'Funzionalità del piano Scuola',
    freeBody: "L'archivio documentale d'istituto (DPA firmati, delibere, verbali, con hash di integrità e versioni) e l'esportazione del dossier ispettivo per strumento sono disponibili con il piano Scuola.",
    tableTitle: 'Archivio documentale',
    emptyTitle: 'Nessun documento in archivio.',
    emptyHint: 'Carica il primo documento con il pulsante in alto a destra.',
    headers: {
      documento: 'Documento',
      tipo: 'Tipo',
      strumento: 'Strumento',
      versione: 'Versione',
      caricato: 'Caricato',
      integrita: 'Integrità',
      azioni: 'Azioni',
    },
    historyLink: 'storico',
    tipo: {
      DPA: 'DPA / Art. 28',
      DELIBERA: 'Delibera',
      VERBALE: 'Verbale',
      INFORMATIVA: 'Informativa',
      NOMINA: 'Nomina',
      ALTRO: 'Altro',
    },
    downloadTitle: 'Scarica',
    newVersionTitle: 'Carica nuova versione',
    deleteTitle: 'Elimina questa versione',
    deleteConfirm: 'Eliminare "{{title}}" (v{{version}})? L\'eliminazione è registrata nell\'audit.',
    toastUploaded: 'Documento caricato',
    toastVersionUploaded: 'Nuova versione caricata',
    toastDeleted: 'Documento eliminato',
    toastUploadKo: 'Caricamento non riuscito',
    toastDeleteKo: 'Eliminazione non riuscita',
    dialog: {
      uploadTitle: "Carica documento d'istituto",
      newVersionTitle: 'Nuova versione — {{title}} (v{{version}})',
      fileLabel: 'File (PDF, Office, immagini, .p7m — max 20 MB)',
      typeLabel: 'Tipo',
      linkedLabel: 'Strumento collegato (facoltativo)',
      linkedNone: 'Nessuno',
      titleLabel: 'Titolo',
      titlePlaceholder: 'Es.: DPA firmato — Fornitore X',
      descLabel: 'Descrizione (facoltativa)',
      submit: 'Carica',
    },
    versionsTitle: 'Storico versioni — {{title}}',
  },
  governance: {
    title: 'Dashboard di governance',
    subtitle: 'verdetti, catena di validazione, scadenze di rivalutazione e copertura del registro.',
    freeTitle: 'Funzionalità del piano Scuola',
    freeBody: "La dashboard di governance d'istituto (distribuzione dei verdetti, backlog della catena di validazione, scadenze di rivalutazione e copertura del registro) è disponibile con il piano Scuola.",
    noSchoolTitle: 'Nessun istituto associato',
    noSchoolBody: "La dashboard mostra i dati dell'istituto di appartenenza. Se sei un DPO esterno che segue più istituti, usa il Cruscotto DPO per l'elenco cross-istituto delle valutazioni da validare.",
    tiles: {
      censiti: 'Strumenti censiti',
      daValidare: 'Da validare (DPO)',
      daAutorizzare: 'Da autorizzare (DS)',
      daRivalutare: 'Da rivalutare',
      incidenti: 'Incidenti aperti',
    },
    verdictTitle: 'Distribuzione dei verdetti',
    verdictDesc: 'Ultimo esito per ciascuno strumento del registro',
    verdictEmpty: 'Nessuno strumento ancora valutato.',
    tooltipTools: 'Strumenti',
    coverageTitle: 'Copertura del registro',
    coverageDesc: 'Strumenti con decisione umana completa sul totale dei censiti',
    coverageOf: '{{decided}} su {{total}} strumenti',
    coverageNote: "Il registro copre solo gli strumenti valutati dall'istituto: strumenti in uso ma mai censiti non compaiono in queste metriche.",
    deadlinesTitle: 'Scadenze di rivalutazione',
    deadlinesDesc: 'Validità scadute o in scadenza nei prossimi 60 giorni (DM 166/2025 §10.1)',
    deadlinesEmpty: 'Nessuna scadenza nei prossimi 60 giorni.',
    expired: 'Scaduta',
    daysLeft: '{{count}} giorni',
    docsFooter: "{{count}} documenti d'istituto in archivio · i dossier ispettivi per strumento si esportano dal Registro.",
  },
  dpo: {
    subtitle: 'Istituti di cui sei Responsabile della Protezione dei Dati',
    noneTitle: 'Non risulti designato come DPO di alcun istituto.',
    noneHint: 'Il Dirigente di una scuola deve indicare la tua email come DPO.',
    assessmentsCount: '{{count}} valutazioni',
    toValidateBadge: '{{count}} da validare',
    noneWaiting: 'Nessuna in attesa',
    allSchools: 'Tutti gli istituti',
    toValidateSection: 'Da validare',
    handledSection: 'Già gestite',
    filterAll: 'Tutte',
    chainState: 'Stato catena',
    notInChain: 'Non inoltrata',
    emptyList: 'Nessuna valutazione trovata.',
    emptyToValidate: 'Nessuna valutazione in attesa di validazione.',
    authorized: 'Autorizzata',
    validatedWaiting: 'Validata (in attesa Dirigente)',
    rowToValidate: 'Da validare',
    examine: 'Esamina',
  },
  assessment: {
    new: 'Nuova Valutazione',
    edit: 'Modifica Valutazione',
    step0Title: 'Screening Pratiche Vietate',
    prohibitedIntro: 'Verifica preliminare ai sensi dell\'Art. 5 del Regolamento (UE) 2024/1689. Se una di queste pratiche è presente, l\'applicazione è vietata nell\'UE dal 2 febbraio 2025.',
    prohibitedQuestion: 'L\'applicazione svolge una delle seguenti pratiche?',
    prohibitedNone: 'Nessuna delle pratiche elencate è presente',
    prohibitedWarningTitle: 'Pratica vietata rilevata',
    prohibitedWarningBody: 'La valutazione si concluderà automaticamente con verdetto VIETATO ai sensi dell\'Art. 5 AI Act, senza analisi ulteriore. L\'esito sarà comunque registrato nel sistema come evidenza documentale.',
    prohibitedPractices: {
      manipolazione_subliminale: 'Tecniche subliminali o manipolative per distorcere il comportamento',
      sfruttamento_vulnerabilita: 'Sfruttamento di vulnerabilità legate a età o disabilità',
      social_scoring: 'Punteggio sociale (social scoring) delle persone',
      scraping_facciale: 'Estrazione indiscriminata di immagini facciali dal web (scraping)',
      riconoscimento_emozioni: 'Riconoscimento delle emozioni di studenti o personale',
      categorizzazione_biometrica: 'Categorizzazione biometrica basata su dati sensibili',
    },
    step1Title: 'Identificazione Applicazione',
    step2Title: 'Contesto d\'Uso',
    step3Title: 'Dati Trattati',
    step4Title: 'Riepilogo e Avvio',
    appName: 'Nome Applicazione',
    appNamePlaceholder: 'Es. ChatGPT, Google Gemini, Khan Academy…',
    vendor: 'Vendor / Fornitore',
    vendorPlaceholder: 'Es. OpenAI, Google, Khan Academy Inc.',
    websiteUrl: 'Sito Ufficiale',
    websiteUrlPlaceholder: 'https://...',
    category: 'Categoria',
    context: 'Contesto d\'uso',
    userType: 'Tipologia utenti finali',
    includesMinors: 'Include utenti minorenni (< 18 anni)',
    minorsAgeBand: 'Fascia d\'età dei minori (L. 132/2025)',
    minorsAgeBands: {
      U14: 'Minori di 14 anni',
      A14_17: 'Minori tra 14 e 17 anni',
      BOTH: 'Entrambe le fasce (< 14 e 14-17)',
    },
    parentalConsent: 'È previsto un meccanismo di consenso genitoriale per i minori di 14 anni',
    parentalConsentWarning: 'Art. 4 L. 132/2025: per i minori di 14 anni l\'accesso a sistemi di IA richiede il consenso di chi esercita la responsabilità genitoriale. In assenza di un meccanismo di consenso dichiarato, il verdetto massimo sarà GIALLO.',
    a1417Info: 'Per i minori tra 14 e 17 anni la L. 132/2025 richiede informative in linguaggio semplice, chiaro e accessibile.',
    estimatedUsers: 'Numero utenti stimato',
    usageFrequency: 'Frequenza d\'uso prevista',
    dataInputs: 'Dati inseriti nell\'applicazione',
    dataNotes: 'Note aggiuntive sui dati',
    startAnalysis: 'Avvia Valutazione',
    pipeline: {
      title: 'Analisi in corso',
      search: 'Ricerca web',
      analysis: 'Analisi normativa',
      scoring: 'Punteggi e verdetto',
      report: 'Report PDF',
      reportRequester: 'Esito a video',
      hint: 'La valutazione richiede in genere 1-2 minuti. Puoi lasciare questa pagina: il risultato sarà disponibile nella cronologia.',
    },
    analyzing: 'Analisi in corso…',
    searchingWeb: 'Ricerca web in corso…',
    analyzingWithAI: 'Analisi regolatoria con IA…',
    completed: 'Analisi completata',
    failed: 'Analisi fallita',
    retryAnalysis: 'Riesegui Analisi',
    downloadReport: 'Scarica PDF',
    categories: {
      TUTORING_IA: 'Tutoring IA',
      GENERAZIONE_CONTENUTI: 'Generazione Contenuti',
      VALUTAZIONE_AUTOMATICA: 'Valutazione Automatica',
      ROBOTICA_LAB: 'Robotica / Lab',
      AMMINISTRAZIONE: 'Amministrazione',
      ALTRO: 'Altro',
    },
    contexts: {
      SEGRETERIA: 'Segreteria (automazione processi)',
      LABORATORIO: 'Laboratorio (robotica, STEM)',
      CLASSE: 'Classe (didattica, apprendimento)',
    },
    userTypes: {
      GOVERNANCE: 'Governance (Dirigenza, DPO)',
      SEGRETERIA: 'Personale di Segreteria',
      DOCENTI: 'Docenti',
      ALUNNI: 'Alunni',
    },
    dataInputTypes: {
      prompt_liberi: 'Prompt liberi (testo generico)',
      dati_anagrafici: 'Dati anagrafici studenti',
      dati_valutazione: 'Dati di valutazione / voti',
      file_allegati: 'File e allegati',
      dati_biometrici: 'Dati biometrici (es. riconoscimento facciale)',
      dati_comportamentali: 'Dati comportamentali / disciplinari',
      nessun_dato_personale: 'Nessun dato personale',
    },
    verdictLabels: {
      VERDE: 'App Approvata',
      GIALLO: 'Sperimentazione Limitata',
      ROSSO: 'Uso Non Raccomandato',
      VIETATO: 'Pratica Vietata – Art. 5 AI Act',
    },
    verdictDesc: {
      VERDE: 'Questa applicazione può essere utilizzata con le linee guida indicate.',
      GIALLO: 'Uso consentito in modalità sperimentale con supervisione rinforzata.',
      ROSSO: 'Uso vietato o fortemente sconsigliato. Consultare il DPO.',
      VIETATO: 'Pratica di IA vietata nell\'Unione Europea dal 2 febbraio 2025. L\'uso non è autorizzabile in alcuna configurazione.',
    },
    dimensions: {
      ETICA: 'Etica e Bias',
      TECNICA: 'Sicurezza Tecnica',
      NORMATIVA_AI_ACT: 'AI Act (Reg. UE 2024/1689)',
      NORMATIVA_GDPR_MIM: 'GDPR & MIM DM 166/2025',
      SUPERVISIONE_UMANA: 'Supervisione Umana',
    },
    tabs: {
      overview: 'Panoramica',
      dimensions: 'Dimensioni',
      recommendations: 'Raccomandazioni',
      mitigation: 'Piano Mitigazione',
      sources: 'Fonti Web',
      dpia: 'DPIA',
      fria: 'FRIA',
    },
    friaSectionTitle: 'FRIA – Valutazione d\'Impatto sui Diritti Fondamentali',
    friaNote: 'Il sistema è classificato ad alto rischio: l\'istituto, in quanto organismo pubblico, è tenuto alla FRIA prima della messa in uso (Art. 27 Reg. UE 2024/1689). Questo template preliminare deve essere completato e approvato da Dirigente e DPO.',
    friaRights: 'Rischi per i diritti fondamentali',
    friaRight: 'Diritto interessato',
    friaRisk: 'Rischio specifico',
    friaProbability: 'Probabilità',
    friaOversight: 'Misure di supervisione umana',
    friaGovernance: 'Misure di governance',
    friaRequired: 'FRIA Richiesta',
    normativeRef: 'Riferimenti normativi',
    recommendations: 'Raccomandazioni Operative',
    mitigationPlan: 'Piano di Mitigazione Rischi',
    mitigationRisk: 'Rischio',
    mitigationMeasure: 'Misura',
    mitigationOwner: 'Responsabile',
    mitigationDeadline: 'Scadenza',
    mitigationPriority: 'Priorità',
    webSources: 'Fonti Web Consultate',
    dpiaRequired: 'DPIA Richiesta',
    dpiaNotRequired: 'DPIA Non Richiesta',
    dpiaSectionTitle: 'Data Protection Impact Assessment',
    webSearchUnavailable: 'Ricerca web non disponibile – analisi basata sui parametri dichiarati',
    revalidation: {
      title: 'Da rivalutare — revisione periodica',
      expired: 'La validità di questa valutazione è scaduta il {{date}} (DM 166/2025 §10.1): l\'esito e l\'eventuale autorizzazione non sono più considerati attuali. Avvia una ri-analisi con il pulsante di aggiornamento.',
      engineOutdated: 'Le regole o il prompt del motore di valutazione sono stati aggiornati dopo questa analisi: l\'esito va riprodotto con il motore corrente. Avvia una ri-analisi con il pulsante di aggiornamento.',
      validUntil: 'Valida fino al {{date}}',
    },
    version: 'Versione',
    runs: {
      title: 'Storico versioni',
      subtitle: 'Esiti precedenti di questa valutazione, conservati in sola lettura a ogni ri-analisi.',
      archivedAt: 'Archiviata il',
      score: 'Punteggio',
      engine: 'Motore',
      dpoValidated: 'Validata dal DPO',
      authorized: 'Autorizzata dal Dirigente',
      overridden: 'Verdetto modificato dal revisore',
      noValidation: 'Nessuna validazione umana',
      originalVerdict: 'Verdetto IA originale',
      notesDpo: 'Note DPO',
      notesReviewer: 'Note Dirigente',
    },
    review: {
      pendingTitle: 'Verdetto IA in attesa di validazione',
      pendingBody: 'Questo verdetto è stato generato con il supporto di IA e deve essere validato da DPO o Dirigente Scolastico prima di costituire una decisione definitiva (Art. 14 Reg. UE 2024/1689).',
      pendingBadge: 'Da validare',
      approve: 'Approva verdetto',
      override: 'Modifica verdetto',
      overrideTitle: 'Modifica verdetto IA',
      overrideDesc: 'Il verdetto modificato sostituirà quello generato dall\'IA. La motivazione è obbligatoria e sarà registrata nell\'audit log e nel report PDF.',
      newVerdict: 'Nuovo verdetto',
      notes: 'Motivazione',
      notesPlaceholder: 'Motivazione della modifica (obbligatoria)…',
      approvedBy: 'Verdetto autorizzato da',
      overriddenBy: 'Verdetto modificato da',
      originalVerdict: 'Verdetto IA originale',
      reviewSuccess: 'Validazione registrata',
      reviewError: 'Errore nella validazione',
      confirmApprove: 'Confermi la validazione del verdetto generato dall\'IA?',
      dpoStageTitle: 'Analizzato — in attesa di validazione del DPO',
      dpoStageBody: 'Il verdetto è stato generato dall\'IA. Il DPO deve validarlo prima che il Dirigente possa autorizzarne l\'uso (Art. 14 Reg. UE 2024/1689).',
      authStageTitle: 'Validato dal DPO — in attesa di autorizzazione del Dirigente',
      authStageBody: 'Il DPO ha validato la valutazione. Il Dirigente Scolastico può ora autorizzarne l\'uso nell\'istituto.',
      validate: 'Valida (DPO)',
      validateOverride: 'Valida con modifica',
      authorize: 'Autorizza (Dirigente)',
      authorizeOverride: 'Autorizza con modifica',
      waitDpo: 'In attesa della validazione del DPO.',
      waitDir: 'In attesa dell\'autorizzazione del Dirigente Scolastico.',
      dpoValidatedBy: 'Validato dal DPO',
      confirmValidate: 'Confermi la validazione DPO del verdetto?',
      confirmAuthorize: 'Confermi l\'autorizzazione del verdetto?',
    },
  },
  reviewQueue: {
    title: 'Valutazioni da Validare',
    subtitle: 'Verdetti IA della scuola in attesa di validazione umana (Art. 14 AI Act)',
    empty: 'Nessuna valutazione in attesa di validazione.',
    author: 'Valutatore',
    examine: 'Esamina',
    pendingCount: 'valutazioni da validare',
  },
  notifications: {
    title: 'Notifiche',
    empty: 'Nessuna notifica.',
    markAllRead: 'Segna tutte come lette',
    types: {
      REVIEW_REQUESTED: 'Nuova valutazione da validare: {{app}}',
      DPO_VALIDATED: 'Valutazione validata dal DPO: {{app}}',
      DECISION_APPROVED: 'Il Dirigente ha autorizzato il verdetto di {{app}}: {{verdict}}',
      DECISION_OVERRIDDEN: 'Il Dirigente ha modificato il verdetto di {{app}}: {{verdict}}',
      SUBSCRIPTION_EXPIRING: 'L\'abbonamento della scuola scade tra {{days}} giorni ({{date}})',
      ASSESSMENT_EXPIRING: 'La valutazione di {{app}} scade tra {{days}} giorni',
      ASSESSMENT_EXPIRED: 'Valutazione scaduta: {{app}} è da rivalutare',
      ENGINE_BUMP: 'Motore di valutazione aggiornato: {{count}} valutazioni da rivalutare',
      INCIDENT_OPENED: 'Strumento sospeso: {{app}} — richiesta analisi DPO',
      INCIDENT_DPO_ANALYZED: 'Analisi DPO registrata per {{app}} — attesa decisione del Dirigente',
      INCIDENT_RESTORED: 'Incidente chiuso: {{app}} ripristinato dal Dirigente',
      INCIDENT_REVOKED: 'Incidente chiuso: {{app}} revocato dal Dirigente',
      INCIDENT_LIFTED: 'Revoca ripristinata: {{app}} torna nel registro',
    },
  },
  audit: {
    title: 'Registro Audit',
    accessRestricted: 'Accesso riservato a DPO e Dirigente Scolastico',
    exportCsv: 'Esporta CSV',
    filterByUser: 'Filtra per utente',
    filterByAction: 'Filtra per azione',
    filterByDate: 'Filtra per data',
    columns: {
      timestamp: 'Data / Ora',
      user: 'Utente',
      action: 'Azione',
      entity: 'Entità',
      ip: 'IP',
      details: 'Dettagli',
    },
  },
  profile: {
    title: 'Profilo Utente',
    role: 'Ruolo',
    school: 'Istituto',
    language: 'Lingua preferita',
    saveChanges: 'Salva Modifiche',
    changeRole: 'Cambia Ruolo',
    joinSchool: 'Associa Istituto',
  },
  errors: {
    networkError: 'Errore di rete. Verifica la connessione.',
    analysisError: 'Errore durante l\'analisi. Riprova.',
    rateLimit: 'Limite raggiunto. Riprova tra qualche ora.',
    generic: 'Si è verificato un errore. Riprova.',
  },
  maintenance: {
    pageTitle: 'Modalità manutenzione',
    pageSubtitle: "Chiude temporaneamente l'applicativo a tutti tranne l'amministratore di piattaforma.",
    statusActive: 'Manutenzione attiva',
    statusInactive: 'Applicativo regolarmente in funzione',
    activeSince: 'Attiva dal {{date}}',
    messageLabel: 'Messaggio per chi prova ad accedere',
    messagePlaceholder: 'Es: stiamo correggendo un errore sui dati del registro. Torniamo operativi entro le 18:00.',
    reopenLabel: 'Rientro previsto',
    reopenHint: "Indicazione per chi legge, non un timer: allo scadere la manutenzione resta attiva finché non premi Disattiva.",
    activate: 'Attiva manutenzione',
    deactivate: 'Disattiva',
    activated: 'Manutenzione attivata',
    deactivated: 'Manutenzione disattivata',
    messageTooShort: 'Scrivi almeno qualche parola sul motivo',
    noticeTitle: 'Preavviso programmato',
    noticeSubtitle: "Annuncia un intervento prima che avvenga. Pubblicarlo non attiva la manutenzione: all'ora indicata va avviata a mano.",
    noticeStart: 'Inizio annunciato',
    noticeEnd: 'Fine annunciata',
    noticeReason: 'Motivo',
    noticeReasonPlaceholder: 'Es: migrazione del database, rientro entro le 19:00',
    noticePublish: 'Pubblica preavviso',
    noticeWithdraw: 'Ritira preavviso',
    noticePublished: 'Preavviso pubblicato',
    noticeWithdrawn: 'Preavviso ritirato',
    noticeNone: 'Nessun preavviso pubblicato.',
    noticeCurrent: 'Preavviso pubblicato per il periodo indicato:',
    noticeDue: "L'ora annunciata è arrivata: i campi qui sopra sono precompilati con quanto promesso.",
    noticeWithdrawHint: "Se l'intervento salta, ritiralo: un preavviso rimasto in pagina insegna a ignorare il prossimo.",
    bannerLabel: 'Intervento programmato',
    closureTitle: 'Applicativo in manutenzione',
    closureBody: "L'applicativo è temporaneamente non disponibile.",
    closureReopen: 'Rientro previsto: {{date}}',
    closureNoReopen: 'Non è stato indicato un orario di rientro.',
    closureContact: 'Per urgenze, contatta la segreteria del tuo istituto.',
    adminLogin: 'Accesso amministratore',
  },
  session: {
    warningTitle: 'Sessione in scadenza',
    warningBody: 'Per sicurezza la sessione di lavoro si chiude tra poco. Rinnovala per continuare senza rifare l\'accesso.',
    renew: 'Rinnova sessione',
    expired: 'Sessione scaduta. Accedi di nuovo.',
  },
}

const en: typeof it = {
  common: {
    loading: 'Loading…',
    error: 'Error',
    save: 'Save',
    cancel: 'Cancel',
    confirm: 'Confirm',
    delete: 'Delete',
    edit: 'Edit',
    close: 'Close',
    back: 'Back',
    next: 'Next',
    submit: 'Submit',
    search: 'Search',
    filter: 'Filters',
    export: 'Export',
    download: 'Download',
    share: 'Share',
    yes: 'Yes',
    no: 'No',
    all: 'All',
    none: 'None',
    notAvailable: 'N/A',
    required: 'Required field',
    optional: 'Optional',
    actions: 'Actions',
    details: 'Details',
    version: 'Version',
    date: 'Date',
    status: 'Status',
    score: 'Score',
    verdict: 'Verdict',
    note: 'Notes',
    label: 'Label',
    results: 'Results',
    page: 'Page',
    of: 'of',
    open: 'Open',
    unexpectedError: 'Unexpected error',
    previous: 'Previous',
  },
  nav: {
    dashboard: 'Dashboard',
    newAssessment: 'New Assessment',
    reviewQueue: 'To Validate',
    audit: 'Audit Log',
    profile: 'Profile',
    logout: 'Sign Out',
    darkMode: 'Dark Mode',
    lightMode: 'Light Mode',
    language: 'Language',
    history: 'History',
    historyPersonal: 'Personal history',
    registro: 'AI tools register',
    documenti: 'School documents',
    guida: 'Guide',
    governance: 'School governance',
    school: 'My School',
    platform: 'Platform',
    maintenance: 'Maintenance mode',
    dpoDashboard: 'DPO Dashboard',
    activityLog: 'Activity log',
    reviewQueueCrumb: 'Review queue',
    newAssessmentCrumb: 'New assessment',
    assessmentCrumb: 'Assessment',
    menu: 'Menu',
    management: 'Management',
    searchCmd: 'Search…',
    home: 'Home',
    skipToContent: 'Skip to content',
    openMenu: 'Open navigation menu',
    closeMenu: 'Close navigation menu',
    breadcrumb: 'Breadcrumb',
    tagline: 'AI Risk at School',
    delegationBadge: 'Head delegation until {{date}}',
    delegationTitle: 'Delegation from Principal {{name}} — valid until {{date}}',
    footerTagline: 'AI Risk Assessment for Schools',
    footerDesign: 'Interface compliant with the .italia Design System',
  },
  palette: {
    placeholder: 'Search assessments, navigate, run actions…',
    noResults: 'No results.',
    navigation: 'Navigation',
    actionsGroup: 'Actions',
    recent: 'Recent assessments',
    toggleTheme: 'Toggle theme',
    navigateHint: 'navigate',
    openHint: 'open',
  },
  auth: {
    loginTitle: 'Sign in to ValutazIA',
    loginSubtitle: 'AI Risk Assessment for Schools',
    loginGoogle: 'Sign in with Google',
    loginMicrosoft: 'Sign in with Microsoft 365',
    loginDesc: 'Use your school institutional account to access the system.',
    logoutSuccess: 'Successfully signed out',
    unauthorized: 'Authentication required',
    forbidden: 'Access denied',
    sessionExpired: 'Session expired. Please sign in again.',
  },
  dashboard: {
    title: 'Dashboard',
    welcome: 'Welcome',
    totalAssessments: 'Total assessments',
    completedAssessments: 'Completed',
    recentAssessments: 'Recent assessments',
    newAssessment: 'New Assessment',
    viewAll: 'View all',
    noAssessments: 'No assessments found. Start with a new assessment.',
    eyebrow: 'Overview',
    stats: {
      verde: 'Approved Apps',
      giallo: 'Limited Use',
      rosso: 'Non-Compliant',
    },
    charts: {
      overTime: 'Assessments over time',
      byMonth: 'Verdicts by month',
      total: 'Total',
      verde: 'Green',
      giallo: 'Yellow',
      rosso: 'Red',
      vietato: 'Prohibited',
    },
    news: {
      title: 'Regulatory Updates',
      framework: 'Regulatory framework',
      aiact: {
        title: 'AI Act in force',
        body: 'Regulation (EU) 2024/1689 applies from August 2, 2026. Schools must classify AI systems in use.',
      },
      mim: {
        title: 'MIM Guidelines DM 166/2025',
        body: 'The Italian Ministry of Education has published guidelines for responsible AI use in Italian schools.',
      },
    },
  },
  quota: {
    titleFree: 'Free plan · {{used}}/{{quota}} assessments used',
    titleSchool: 'School plan · {{used}}/{{quota}} assessments used this year',
    exhaustedFree: 'You have reached the free plan limit. Upgrade to a paid plan to continue.',
    exhaustedSchool: 'Your school has reached the assessments included in its plan for this school year. Contact the Dirigente or DPO about an upgrade.',
    remaining_one: 'You have 1 left.',
    remaining_other: 'You have {{count}} left.',
  },
  history: {
    title: 'History of assessment requests',
    items: 'items',
    searchPlaceholder: 'Search by tool name…',
    searchAria: 'Search assessments by tool name',
    noResults: 'No assessments found for "{{search}}".',
    empty: "You haven't run any assessments yet.",
    createFirst: 'Create your first assessment',
  },
  registro: {
    eyebrow: 'School AI governance',
    title: 'Register of authorized AI tools',
    subtitle: 'AI tools validated and authorized for use in your institution.',
    demoTitle: 'Demo data',
    demoBody: 'This table is a demonstration example. With the school plan the register is fed by assessments validated by the DPO/Principal and reflects the tools actually authorized in your school.',
    tableTitle: 'Registered tools',
    tableTitleDemo: 'Registered tools (example)',
    headers: {
      strumento: 'Tool',
      fornitore: 'Vendor',
      categoria: 'Category',
      stato: 'Status',
      validazione: 'Validation',
      note: 'Notes',
      azioni: 'Actions',
    },
    stato: {
      AUTORIZZATO: 'Authorized',
      CON_LIMITAZIONI: 'With limitations',
      SOSPESO: 'Suspended',
      DA_RIVALUTARE: 'To reassess',
      NON_AUTORIZZATO: 'Not authorized',
      VALIDATO_DPO: 'Validated by DPO',
      ANALIZZATO: 'Analyzed',
      REVOCATO: 'Revoked',
    },
    pending: 'Pending',
    pendingAuth: 'Awaiting authorization',
    emptyTitle: 'No tools in the register yet.',
    emptyHint: "The school's completed assessments will appear here; once validated by the DPO/Principal they will show as authorized.",
    validatedBy: 'Validated by {{name}}',
    revalidationExpired: 'Validity expired on {{date}} — re-analysis required (DM 166/2025 §10.1)',
    revalidationEngine: 'Assessment engine updated — re-analysis required',
    incident: {
      revoked: 'Revoked by the Principal — {{reason}}',
      revokedOn: 'Revoked by the Principal on {{date}} — {{reason}}',
      analyzed: 'Suspended on {{date}} — DPO analysis recorded, awaiting the Principal\'s decision',
      waitingDpo: 'Suspended on {{date}} — awaiting DPO analysis',
      waitingDpoBy: 'Suspended on {{date}} by {{name}} — awaiting DPO analysis',
    },
    actions: {
      suspend: 'Suspend',
      dpo: 'DPO analysis',
      decide: 'Decide',
      lift: 'Restore',
      waitDpo: 'Awaiting DPO analysis',
      waitDs: 'Awaiting Principal decision',
      dossier: 'Dossier',
      dossierTitle: 'Download the inspection dossier (assessments, reports, runs, incidents, documents, audit)',
    },
    dialog: {
      suspendTitle: 'Suspend the tool',
      dpoTitle: 'Record DPO analysis',
      decideTitle: "Principal's decision",
      liftTitle: 'Restore the tool',
      suspendInfo: "The suspension is immediate and visible to the whole school. The process continues with the DPO's analysis and the Principal's decision (restore or revoke).",
      dpoAnalysisOf: 'DPO analysis',
      decision: 'Decision',
      restoreOption: 'Restore — the tool returns to its chain status',
      revokeOption: 'Revoke — the tool stays blocked as REVOKED',
      suspendLabel: 'Reason (required, min 20 characters)',
      dpoLabel: 'DPO analysis (required, min 20 characters)',
      decideLabel: 'Notes (optional)',
      liftLabel: 'Restore reason (required, min 20 characters)',
      suspendPlaceholder: 'E.g.: vendor data breach reported on 10/07…',
    },
    toastOk: 'Operation recorded',
    toastKo: 'Operation failed',
    demo: {
      catContenuti: 'Content generation',
      catTutoring: 'AI tutoring',
      catAmministrazione: 'Administration',
      catRicerca: 'Research',
      noteChatgpt: 'Teachers only, no student personal data',
      noteGemini: 'Institutional Workspace accounts',
      noteCopilot: 'Used in the admin office',
      noteCanva: 'Ongoing incident: DPO analysis',
      noteKhanmigo: 'Validated by the DPO, awaiting authorization',
      notePerplexity: 'AI-analyzed, not yet validated',
    },
  },
  documenti: {
    eyebrow: 'School AI governance',
    title: 'School documents',
    subtitle: 'DPAs, resolutions, minutes and appointments with SHA-256 hash and versions. Documents linked to a tool become part of its inspection dossier.',
    upload: 'Upload document',
    freeTitle: 'School plan feature',
    freeBody: 'The school document archive (signed DPAs, resolutions, minutes, with integrity hash and versions) and the per-tool inspection dossier export are available with the School plan.',
    tableTitle: 'Document archive',
    emptyTitle: 'No documents in the archive.',
    emptyHint: 'Upload the first document with the button at the top right.',
    headers: {
      documento: 'Document',
      tipo: 'Type',
      strumento: 'Tool',
      versione: 'Version',
      caricato: 'Uploaded',
      integrita: 'Integrity',
      azioni: 'Actions',
    },
    historyLink: 'history',
    tipo: {
      DPA: 'DPA / Art. 28',
      DELIBERA: 'Resolution',
      VERBALE: 'Minutes',
      INFORMATIVA: 'Privacy notice',
      NOMINA: 'Appointment',
      ALTRO: 'Other',
    },
    downloadTitle: 'Download',
    newVersionTitle: 'Upload new version',
    deleteTitle: 'Delete this version',
    deleteConfirm: 'Delete "{{title}}" (v{{version}})? The deletion is recorded in the audit log.',
    toastUploaded: 'Document uploaded',
    toastVersionUploaded: 'New version uploaded',
    toastDeleted: 'Document deleted',
    toastUploadKo: 'Upload failed',
    toastDeleteKo: 'Deletion failed',
    dialog: {
      uploadTitle: 'Upload school document',
      newVersionTitle: 'New version — {{title}} (v{{version}})',
      fileLabel: 'File (PDF, Office, images, .p7m — max 20 MB)',
      typeLabel: 'Type',
      linkedLabel: 'Linked tool (optional)',
      linkedNone: 'None',
      titleLabel: 'Title',
      titlePlaceholder: 'E.g.: Signed DPA — Vendor X',
      descLabel: 'Description (optional)',
      submit: 'Upload',
    },
    versionsTitle: 'Version history — {{title}}',
  },
  governance: {
    title: 'Governance dashboard',
    subtitle: 'verdicts, validation chain, re-assessment deadlines and register coverage.',
    freeTitle: 'School plan feature',
    freeBody: 'The school governance dashboard (verdict distribution, validation chain backlog, re-assessment deadlines and register coverage) is available with the School plan.',
    noSchoolTitle: 'No school associated',
    noSchoolBody: 'The dashboard shows data for your own school. If you are an external DPO following several schools, use the DPO Dashboard for the cross-school list of assessments to validate.',
    tiles: {
      censiti: 'Tools on record',
      daValidare: 'To validate (DPO)',
      daAutorizzare: 'To authorize (Principal)',
      daRivalutare: 'To reassess',
      incidenti: 'Open incidents',
    },
    verdictTitle: 'Verdict distribution',
    verdictDesc: 'Latest outcome for each tool in the register',
    verdictEmpty: 'No tools assessed yet.',
    tooltipTools: 'Tools',
    coverageTitle: 'Register coverage',
    coverageDesc: 'Tools with a complete human decision out of all on record',
    coverageOf: '{{decided}} of {{total}} tools',
    coverageNote: 'The register only covers tools assessed by the school: tools in use but never recorded do not appear in these metrics.',
    deadlinesTitle: 'Re-assessment deadlines',
    deadlinesDesc: 'Expired or expiring within the next 60 days (DM 166/2025 §10.1)',
    deadlinesEmpty: 'No deadlines in the next 60 days.',
    expired: 'Expired',
    daysLeft: '{{count}} days',
    docsFooter: '{{count}} school documents in the archive · per-tool inspection dossiers are exported from the Register.',
  },
  dpo: {
    subtitle: 'Schools where you are the Data Protection Officer',
    noneTitle: 'You are not designated as DPO for any school.',
    noneHint: "A school's Principal must set your email as the DPO.",
    assessmentsCount: '{{count}} assessments',
    toValidateBadge: '{{count}} to validate',
    noneWaiting: 'None pending',
    allSchools: 'All schools',
    toValidateSection: 'To validate',
    handledSection: 'Already handled',
    filterAll: 'All',
    chainState: 'Chain status',
    notInChain: 'Not submitted',
    emptyList: 'No assessments found.',
    emptyToValidate: 'No assessments awaiting validation.',
    authorized: 'Authorized',
    validatedWaiting: 'Validated (awaiting Principal)',
    rowToValidate: 'To validate',
    examine: 'Review',
  },
  assessment: {
    new: 'New Assessment',
    edit: 'Edit Assessment',
    step0Title: 'Prohibited Practices Screening',
    prohibitedIntro: 'Preliminary check under Art. 5 of Regulation (EU) 2024/1689. If any of these practices is present, the application has been banned in the EU since 2 February 2025.',
    prohibitedQuestion: 'Does the application perform any of the following practices?',
    prohibitedNone: 'None of the listed practices is present',
    prohibitedWarningTitle: 'Prohibited practice detected',
    prohibitedWarningBody: 'The assessment will automatically conclude with a PROHIBITED verdict under Art. 5 AI Act, without further analysis. The outcome will still be recorded in the system as documentary evidence.',
    prohibitedPractices: {
      manipolazione_subliminale: 'Subliminal or manipulative techniques distorting behaviour',
      sfruttamento_vulnerabilita: 'Exploitation of vulnerabilities related to age or disability',
      social_scoring: 'Social scoring of individuals',
      scraping_facciale: 'Untargeted scraping of facial images from the web',
      riconoscimento_emozioni: 'Emotion recognition of students or staff',
      categorizzazione_biometrica: 'Biometric categorisation based on sensitive data',
    },
    step1Title: 'Application Identification',
    step2Title: 'Usage Context',
    step3Title: 'Data Processed',
    step4Title: 'Review & Start',
    appName: 'Application Name',
    appNamePlaceholder: 'E.g. ChatGPT, Google Gemini, Khan Academy…',
    vendor: 'Vendor / Provider',
    vendorPlaceholder: 'E.g. OpenAI, Google, Khan Academy Inc.',
    websiteUrl: 'Official Website',
    websiteUrlPlaceholder: 'https://...',
    category: 'Category',
    context: 'Usage Context',
    userType: 'End Users Type',
    includesMinors: 'Includes minor users (< 18 years)',
    minorsAgeBand: 'Minors age band (Italian Law 132/2025)',
    minorsAgeBands: {
      U14: 'Under 14 years old',
      A14_17: 'Between 14 and 17 years old',
      BOTH: 'Both bands (< 14 and 14-17)',
    },
    parentalConsent: 'A parental consent mechanism is in place for users under 14',
    parentalConsentWarning: 'Art. 4 Law 132/2025: access to AI systems by minors under 14 requires the consent of those exercising parental responsibility. Without a declared consent mechanism, the maximum verdict will be YELLOW.',
    a1417Info: 'For minors aged 14-17, Law 132/2025 requires notices written in simple, clear and accessible language.',
    estimatedUsers: 'Estimated number of users',
    usageFrequency: 'Expected usage frequency',
    dataInputs: 'Data entered into the application',
    dataNotes: 'Additional data notes',
    startAnalysis: 'Start Assessment',
    pipeline: {
      title: 'Analysis in progress',
      search: 'Web research',
      analysis: 'Regulatory analysis',
      scoring: 'Scores & verdict',
      report: 'PDF report',
      reportRequester: 'On-screen outcome',
      hint: 'The assessment usually takes 1-2 minutes. You can leave this page: the result will be available in the history.',
    },
    analyzing: 'Analysis in progress…',
    searchingWeb: 'Web search in progress…',
    analyzingWithAI: 'Regulatory AI analysis…',
    completed: 'Analysis completed',
    failed: 'Analysis failed',
    retryAnalysis: 'Re-run Analysis',
    downloadReport: 'Download PDF',
    categories: {
      TUTORING_IA: 'AI Tutoring',
      GENERAZIONE_CONTENUTI: 'Content Generation',
      VALUTAZIONE_AUTOMATICA: 'Automated Assessment',
      ROBOTICA_LAB: 'Robotics / Lab',
      AMMINISTRAZIONE: 'Administration',
      ALTRO: 'Other',
    },
    contexts: {
      SEGRETERIA: 'Office (administrative automation)',
      LABORATORIO: 'Laboratory (robotics, STEM)',
      CLASSE: 'Classroom (teaching, learning)',
    },
    userTypes: {
      GOVERNANCE: 'Governance (Principal, DPO)',
      SEGRETERIA: 'Administrative Staff',
      DOCENTI: 'Teachers',
      ALUNNI: 'Students',
    },
    dataInputTypes: {
      prompt_liberi: 'Free prompts (generic text)',
      dati_anagrafici: 'Student personal data',
      dati_valutazione: 'Assessment data / grades',
      file_allegati: 'Files and attachments',
      dati_biometrici: 'Biometric data (e.g. face recognition)',
      dati_comportamentali: 'Behavioural / disciplinary data',
      nessun_dato_personale: 'No personal data',
    },
    verdictLabels: {
      VERDE: 'App Approved',
      GIALLO: 'Limited Experimentation',
      ROSSO: 'Use Not Recommended',
      VIETATO: 'Prohibited Practice – Art. 5 AI Act',
    },
    verdictDesc: {
      VERDE: 'This application can be used with the indicated guidelines.',
      GIALLO: 'Use permitted in experimental mode with enhanced supervision.',
      ROSSO: 'Use prohibited or strongly discouraged. Consult the DPO.',
      VIETATO: 'AI practice banned in the European Union since 2 February 2025. Use cannot be authorised in any configuration.',
    },
    dimensions: {
      ETICA: 'Ethics & Bias',
      TECNICA: 'Technical Security',
      NORMATIVA_AI_ACT: 'AI Act (Reg. EU 2024/1689)',
      NORMATIVA_GDPR_MIM: 'GDPR & MIM DM 166/2025',
      SUPERVISIONE_UMANA: 'Human Oversight',
    },
    tabs: {
      overview: 'Overview',
      dimensions: 'Dimensions',
      recommendations: 'Recommendations',
      mitigation: 'Mitigation Plan',
      sources: 'Web Sources',
      dpia: 'DPIA',
      fria: 'FRIA',
    },
    friaSectionTitle: 'FRIA – Fundamental Rights Impact Assessment',
    friaNote: 'The system is classified as high-risk: the school, as a public body, must carry out a FRIA before deployment (Art. 27 Reg. EU 2024/1689). This preliminary template must be completed and approved by the Principal and the DPO.',
    friaRights: 'Risks to fundamental rights',
    friaRight: 'Right concerned',
    friaRisk: 'Specific risk',
    friaProbability: 'Probability',
    friaOversight: 'Human oversight measures',
    friaGovernance: 'Governance measures',
    friaRequired: 'FRIA Required',
    normativeRef: 'Normative references',
    recommendations: 'Operational Recommendations',
    mitigationPlan: 'Risk Mitigation Plan',
    mitigationRisk: 'Risk',
    mitigationMeasure: 'Measure',
    mitigationOwner: 'Owner',
    mitigationDeadline: 'Deadline',
    mitigationPriority: 'Priority',
    webSources: 'Web Sources Consulted',
    dpiaRequired: 'DPIA Required',
    dpiaNotRequired: 'DPIA Not Required',
    dpiaSectionTitle: 'Data Protection Impact Assessment',
    webSearchUnavailable: 'Web search unavailable – analysis based on declared parameters only',
    revalidation: {
      title: 'To re-evaluate — periodic review',
      expired: 'This assessment\'s validity expired on {{date}} (MIM Guidelines §10.1): the outcome and any authorization are no longer considered current. Start a re-analysis with the refresh button.',
      engineOutdated: 'The assessment engine\'s rules or prompt were updated after this analysis: the outcome must be reproduced with the current engine. Start a re-analysis with the refresh button.',
      validUntil: 'Valid until {{date}}',
    },
    version: 'Version',
    runs: {
      title: 'Version history',
      subtitle: 'Previous outcomes of this assessment, kept read-only at every re-analysis.',
      archivedAt: 'Archived on',
      score: 'Score',
      engine: 'Engine',
      dpoValidated: 'Validated by DPO',
      authorized: 'Authorized by the Principal',
      overridden: 'Verdict overridden by the reviewer',
      noValidation: 'No human validation',
      originalVerdict: 'Original AI verdict',
      notesDpo: 'DPO notes',
      notesReviewer: 'Principal notes',
    },
    review: {
      pendingTitle: 'AI verdict awaiting validation',
      pendingBody: 'This verdict was generated with AI support and must be validated by the DPO or School Principal before it constitutes a final decision (Art. 14 Reg. EU 2024/1689).',
      pendingBadge: 'To validate',
      approve: 'Approve verdict',
      override: 'Override verdict',
      overrideTitle: 'Override AI verdict',
      overrideDesc: 'The new verdict will replace the AI-generated one. A justification is mandatory and will be recorded in the audit log and the PDF report.',
      newVerdict: 'New verdict',
      notes: 'Justification',
      notesPlaceholder: 'Reason for the override (mandatory)…',
      approvedBy: 'Verdict authorized by',
      overriddenBy: 'Verdict overridden by',
      originalVerdict: 'Original AI verdict',
      reviewSuccess: 'Validation recorded',
      reviewError: 'Validation error',
      confirmApprove: 'Confirm validation of the AI-generated verdict?',
      dpoStageTitle: 'Analyzed — awaiting DPO validation',
      dpoStageBody: 'The verdict was generated by AI. The DPO must validate it before the Principal can authorize its use (Art. 14 Reg. EU 2024/1689).',
      authStageTitle: 'Validated by the DPO — awaiting Principal authorization',
      authStageBody: 'The DPO has validated the assessment. The School Principal can now authorize its use in the institution.',
      validate: 'Validate (DPO)',
      validateOverride: 'Validate with change',
      authorize: 'Authorize (Principal)',
      authorizeOverride: 'Authorize with change',
      waitDpo: 'Awaiting DPO validation.',
      waitDir: 'Awaiting School Principal authorization.',
      dpoValidatedBy: 'Validated by the DPO',
      confirmValidate: 'Confirm the DPO validation of the verdict?',
      confirmAuthorize: 'Confirm the authorization of the verdict?',
    },
  },
  reviewQueue: {
    title: 'Assessments to Validate',
    subtitle: 'School AI verdicts awaiting human validation (Art. 14 AI Act)',
    empty: 'No assessments awaiting validation.',
    author: 'Assessor',
    examine: 'Review',
    pendingCount: 'assessments to validate',
  },
  notifications: {
    title: 'Notifications',
    empty: 'No notifications.',
    markAllRead: 'Mark all as read',
    types: {
      REVIEW_REQUESTED: 'New assessment awaiting validation: {{app}}',
      DPO_VALIDATED: 'Assessment validated by the DPO: {{app}}',
      DECISION_APPROVED: 'The Principal authorized the verdict of {{app}}: {{verdict}}',
      DECISION_OVERRIDDEN: 'The Principal overrode the verdict of {{app}}: {{verdict}}',
      SUBSCRIPTION_EXPIRING: 'The school subscription expires in {{days}} days ({{date}})',
      ASSESSMENT_EXPIRING: 'The assessment of {{app}} expires in {{days}} days',
      ASSESSMENT_EXPIRED: 'Assessment expired: {{app}} must be re-evaluated',
      ENGINE_BUMP: 'Assessment engine updated: {{count}} assessments to re-evaluate',
      INCIDENT_OPENED: 'Tool suspended: {{app}} — DPO analysis requested',
      INCIDENT_DPO_ANALYZED: 'DPO analysis recorded for {{app}} — awaiting the Principal\'s decision',
      INCIDENT_RESTORED: 'Incident closed: {{app}} restored by the Principal',
      INCIDENT_REVOKED: 'Incident closed: {{app}} revoked by the Principal',
      INCIDENT_LIFTED: 'Revocation lifted: {{app}} back in the register',
    },
  },
  audit: {
    title: 'Audit Log',
    accessRestricted: 'Access restricted to DPO and School Principal',
    exportCsv: 'Export CSV',
    filterByUser: 'Filter by user',
    filterByAction: 'Filter by action',
    filterByDate: 'Filter by date',
    columns: {
      timestamp: 'Date / Time',
      user: 'User',
      action: 'Action',
      entity: 'Entity',
      ip: 'IP',
      details: 'Details',
    },
  },
  profile: {
    title: 'User Profile',
    role: 'Role',
    school: 'School',
    language: 'Preferred language',
    saveChanges: 'Save Changes',
    changeRole: 'Change Role',
    joinSchool: 'Associate School',
  },
  errors: {
    networkError: 'Network error. Please check your connection.',
    analysisError: 'Error during analysis. Please try again.',
    rateLimit: 'Limit reached. Please try again in a few hours.',
    generic: 'An error occurred. Please try again.',
  },
  maintenance: {
    pageTitle: 'Maintenance mode',
    pageSubtitle: 'Temporarily closes the application to everyone but the platform administrator.',
    statusActive: 'Maintenance active',
    statusInactive: 'Application running normally',
    activeSince: 'Active since {{date}}',
    messageLabel: 'Message shown to anyone who tries to access',
    messagePlaceholder: 'E.g.: we are fixing an error in the register data. Back online by 6pm.',
    reopenLabel: 'Expected return',
    reopenHint: 'An indication for readers, not a timer: once it elapses maintenance stays active until you press Deactivate.',
    activate: 'Activate maintenance',
    deactivate: 'Deactivate',
    activated: 'Maintenance activated',
    deactivated: 'Maintenance deactivated',
    messageTooShort: 'Write at least a few words about the reason',
    noticeTitle: 'Scheduled notice',
    noticeSubtitle: "Announce an intervention before it happens. Publishing it does not activate maintenance: it must be started by hand at the announced time.",
    noticeStart: 'Announced start',
    noticeEnd: 'Announced end',
    noticeReason: 'Reason',
    noticeReasonPlaceholder: 'E.g.: database migration, back online by 7pm',
    noticePublish: 'Publish notice',
    noticeWithdraw: 'Withdraw notice',
    noticePublished: 'Notice published',
    noticeWithdrawn: 'Notice withdrawn',
    noticeNone: 'No notice published.',
    noticeCurrent: 'Notice published for the period below:',
    noticeDue: 'The announced time has arrived: the fields above are pre-filled with what was promised.',
    noticeWithdrawHint: 'If the intervention is called off, withdraw it: a notice left on screen teaches readers to ignore the next one.',
    bannerLabel: 'Scheduled intervention',
    closureTitle: 'Application under maintenance',
    closureBody: 'The application is temporarily unavailable.',
    closureReopen: 'Expected return: {{date}}',
    closureNoReopen: 'No return time was indicated.',
    closureContact: 'For urgent matters, contact your school office.',
    adminLogin: 'Administrator login',
  },
  session: {
    warningTitle: 'Session expiring',
    warningBody: 'For security, the work session is about to close. Renew it to keep working without logging in again.',
    renew: 'Renew session',
    expired: 'Session expired. Please log in again.',
  },
}

i18n.use(initReactI18next).init({
  resources: {
    it: { translation: it },
    en: { translation: en },
  },
  lng: localStorage.getItem('varia-lang') || 'it',
  fallbackLng: 'it',
  interpolation: { escapeValue: false },
})

export default i18n
export type TranslationKeys = typeof it
